import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class NeedsClusterRemovedDetailsDto {
  vin?: string = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  importerStockNumber?: string = undefined
  exporterCompany?: CompanyDto = undefined
  clusterPhotosPulledClusterPhotoFileName?: string = undefined
  clusterPhotosPulledClusterPhotoNote?: string = undefined
  clusterPhotosPulledClusterPhotoFile?: File = undefined
}

export const needsClusterRemovedDetailsValidationSchema = yup.object({
  vin: yup.string().nullable(),
  exporterCompany: yup.mixed().nullable(),
  year: yup.number().nullable(),
  make: yup.string().nullable(),
  model: yup.string().nullable(),
  importerStockNumber: yup.string().nullable()
})
